import { useLocation } from 'react-router-dom';
import qs from 'qs';

export const useQueryString = <T extends Record<string, unknown>>() => {
  const location = useLocation();
  const q = qs.parse(location.search, { ignoreQueryPrefix: true });
  return q as T;
};
